import { render, staticRenderFns } from "./AddressAndInfo.vue?vue&type=template&id=5a535640&scoped=true&"
import script from "./AddressAndInfo.vue?vue&type=script&lang=js&"
export * from "./AddressAndInfo.vue?vue&type=script&lang=js&"
import style0 from "./AddressAndInfo.vue?vue&type=style&index=0&id=5a535640&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a535640",
  null
  
)

export default component.exports